<template>
  <div>
    <manager-vacation-tracker
      v-if="isAdmin"
      :manager-id="managerId"
    />
    
    <template v-else>
      <staff-vacation-tracker :staff-id="staffId" />
      
      <manager-vacation-tracker
        v-if="isParent"
        :manager-id="managerId"
      />
    </template>
  </div>
</template>

<script>
export default {
    name: "VacationTrackerManager",
    props: {
        staffId: {
            type: Number,
            required: true,
        },
        managerId: {
            type: Number,
            required: true,
        },
        isAdmin: {
            type: Boolean,
            required: true,
        },
        isParent: {
            type: Boolean,
            required: true,
        },
    },
};
</script>

<style scoped>

</style>
